export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2.5 h-2.5 bg-[#ccff00] block" />
              <span className="font-display text-xl tracking-tight uppercase">
                Pipeline<span className="text-[#ccff00]">Forge</span>
              </span>
            </div>
            <p className="text-sm text-white/50 max-w-sm leading-relaxed">
              Performance-only database reactivation. We resurrect the revenue
              hiding in dormant CRMs — and only get paid when it lands.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Product</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#how" className="hover:text-white">How it works</a></li>
              <li><a href="#calculator" className="hover:text-white">Calculator</a></li>
              <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Contact</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li>paul@pipelineforge.co.uk</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} PipelineForge · No results, no pay. Period.
          </p>
          <p className="font-mono-acc text-[10px] uppercase tracking-widest text-white/30">
            Built for results · Not for vanity dashboards
          </p>
        </div>
      </div>
    </footer>
  );
}
